import {create} from 'zustand';
import {Marketer} from '../models/marketer.model';

export interface MarketerSelectionState {
  marketers: Marketer[];
  selectedMarketer?: Marketer;
  isLoading: boolean;
  error?: string;
}

interface MarketerSelectionStore extends MarketerSelectionState {
  // Actions
  setMarketers: (marketers: Marketer[]) => void;
  setSelectedMarketer: (marketer?: Marketer) => void;
  setLoading: (loading: boolean) => void;
  setError: (error?: string) => void;
  clearSelection: () => void;
  reset: () => void;
}

// دوال مساعدة للمقارنة
const areMarketersEqual = (currentMarketers: Marketer[], newMarketers: Marketer[]): boolean => {
  if (currentMarketers.length !== newMarketers.length) {
    return false;
  }

  const currentIds = new Set(currentMarketers.map(m => m.id));
  const newIds = new Set(newMarketers.map(m => m.id));

  return currentIds.size === newIds.size && [...currentIds].every(id => newIds.has(id));
};

// الحالة الافتراضية
const defaultState: MarketerSelectionState = {
  marketers: [],
  selectedMarketer: undefined,
  isLoading: false,
  error: undefined
};

export const useMarketerSelectionStore = create<MarketerSelectionStore>((set, get) => ({
  ...defaultState,

  setMarketers: (marketers) => {
    const currentMarketers = get().marketers;

    if (!areMarketersEqual(currentMarketers, marketers)) {
      set({marketers});
    }
  },

  setSelectedMarketer: (marketer) => {
    const currentSelectedMarketer = get().selectedMarketer;

    if (currentSelectedMarketer?.id !== marketer?.id) {
      set({selectedMarketer: marketer});
    }
  },

  setLoading: (loading) => {
    const currentLoading = get().isLoading;
    if (currentLoading !== loading) {
      set({isLoading: loading});
    }
  },

  setError: (error) => {
    const currentError = get().error;
    if (currentError !== error) {
      set({error});
    }
  },

  clearSelection: () => {
    const currentSelectedMarketer = get().selectedMarketer;
    if (currentSelectedMarketer) {
      set({selectedMarketer: undefined});
    }
  },

  reset: () => {
    set(defaultState);
  }
}));
